import { render, staticRenderFns } from "./saderat.vue?vue&type=template&id=28801bf6"
import script from "./saderat.vue?vue&type=script&lang=js"
export * from "./saderat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports